import {DocumentTemplateModel} from '../documentTemplate.model';
import {DocumentTemplateSummaryConverter} from './documentTemplateSummary.converter';
import {DocumentSummaryConverter} from '../../../../common/api/converter/documentSummary.converter';
import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";

@Injectable({
    providedIn: 'root'
})
export class DocumentTemplateConverter extends HttpModelConverter<DocumentTemplateModel> {
    constructor(private summaryConverter: DocumentTemplateSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }
    protected createInstance(): DocumentTemplateModel {
        return new DocumentTemplateModel();
    }

    protected enrichObject(result: DocumentTemplateModel, src: DocumentTemplateModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.document = this.documentSummaryConverter.convert(src.document);
    }
}
